import { trackEvent } from "services/frontend/Segment"

export enum CtaType {
    button = "button",
    interstitial = "interstitial",
    banner = "banner"
}

export function useRecordCtaClicked() {

    const recordCtaClicked = (args: {
        ctaType: CtaType,
        ctaText: string,
        ctaDestinationUrl: string
    }) => {
        trackEvent("CTA Clicked",{
            type: args.ctaType ?? '',
            text: args.ctaText ?? '',
            page_url: global?.window?.location?.href ?? '',
            destination: args.ctaDestinationUrl ?? ''
        })
    }

    return recordCtaClicked;
}